import { Link, useLocation } from 'react-router-dom';
import { AppSelector } from './AppSelector';
import { FirebaseProjectSelector } from './FirebaseProjectSelector';

export function Sidebar({ onLogout }) {
  const { pathname } = useLocation();

  const isActive = (page) => {
    if (page === 'dashboard') return pathname === '/dashboard';
    return pathname === `/${page}`;
  };

  return (
    <aside className="w-68 bg-panel border-r border-panel-border flex flex-col min-h-screen">
      {/* Brand */}
      <div className="px-5 py-4 border-b border-panel-border flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-sage-mid to-teal-mid flex items-center justify-center text-white text-lg font-bold">
          +
        </div>
        <div>
          <div className="text-[10px] tracking-[0.14em] font-semibold text-sage-light">
            UNIVERSAL ADMIN
          </div>
          <div className="text-xs font-semibold text-muted">
            Multi-App Panel
          </div>
        </div>
      </div>

      {/* App selector */}
      <div className="px-4 py-3 border-b border-panel-border">
        <AppSelector />
      </div>

      {/* Firebase project filter */}
      <div className="px-4 py-3 border-b border-panel-border">
        <FirebaseProjectSelector />
      </div>

      {/* Navigation */}
      <nav className="px-3 py-4 flex-1">
        <p className="text-[10px] uppercase tracking-[0.16em] text-muted mb-3 px-2">
          Overview
        </p>
        <Link
          to="/dashboard"
          className={`nav-item ${isActive('dashboard') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('dashboard') ? '' : 'dim'}`} />
          <span>Dashboard</span>
        </Link>
        <Link
          to="/users"
          className={`nav-item ${isActive('users') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('users') ? '' : 'dim'}`} />
          <span>Users</span>
        </Link>
        <Link
          to="/usage"
          className={`nav-item ${isActive('usage') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('usage') ? '' : 'dim'}`} />
          <span>AI Usage</span>
        </Link>
        <Link
          to="/ai-learning"
          className={`nav-item ${isActive('ai-learning') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('ai-learning') ? '' : 'dim'}`} />
          <span>AI Learning</span>
        </Link>
        <Link
          to="/notifications"
          className={`nav-item ${isActive('notifications') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('notifications') ? '' : 'dim'}`} />
          <span>Notifications</span>
        </Link>
        <Link
          to="/promos"
          className={`nav-item ${isActive('promos') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('promos') ? '' : 'dim'}`} />
          <span>App Promos</span>
        </Link>

        <p className="text-[10px] uppercase tracking-[0.16em] text-muted mt-5 mb-3 px-2">
          Settings
        </p>
        <Link
          to="/apps"
          className={`nav-item ${isActive('apps') ? 'nav-item-active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          <span className={`nav-dot ${isActive('apps') ? '' : 'dim'}`} />
          <span>Registered Apps</span>
        </Link>
      </nav>

      <div className="px-4 py-4 border-t border-panel-border text-xs text-muted flex items-center justify-between">
        <span>v2.0.0 · Universal</span>
        <button
          type="button"
          onClick={onLogout}
          className="text-rose hover:text-rose-light transition-colors text-[11px] font-semibold bg-transparent border-none cursor-pointer"
        >
          Log out
        </button>
      </div>
    </aside>
  );
}
